import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import * as UserDataConfig from '../config/user-data.config';
import { UtilService, SERVICE_END_POINT } from '../../shared';
import { AnalyticsService } from '../../shared';
import { SyncService } from 'src/app/pages/medical-underwriting/services/sync.service';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { DependantDetails, ProductChoice } from 'src/app/model/ngrx';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { UnderWritingData, AnnuitantMedicalConditions } from 'src/app/pages/medical-underwriting/model';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { MedicalCondQuestionSet } from 'src/app/pages/medical-underwriting/medical-underwrting.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

import * as YourLumpSumActions from '../../store/actions/your-lump-sum-allowances.actions';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [NgClass]
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  public breadcrumbDetails = UserDataConfig.BreadcrumbConfig.data.values.sort((n1, n2) => {
    if (n1.displayOrder > n2.displayOrder) {
      return 1;
    }

    if (n1.displayOrder < n2.displayOrder) {
      return -1;
    }

    return 0;
  });
  breadcrumbs: any;
  arrBreadcrumb: any;
  subscription: any;
  isDataPresent: boolean;
  CMSData: any;
  dependantDetailsData: DependantDetails;
  dependantDetailsStore: Observable<DependantDetails[]>;
  lifeStyleFromStoreObsSubscription: Subscription;
  lifeStylePayloadFromStoreObj: UnderWritingData;
  private totalMedCount: number;
  private medCondListFromStore: AnnuitantMedicalConditions[];
  postProductsChoiceStore: Observable<ProductChoice[]>;
  postProductChoice: ProductChoice;
  isMaturityQuote: boolean = false;
  
  constructor(private router: Router, private utilService: UtilService,
    private syncService: SyncService,
    private analyticsService: AnalyticsService,
    private store: Store<AppState>,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService,) {
    this.syncService.getMCDashboardObj().subscribe(res => {
      this.isDataPresent = res;
    });

    this.postProductsChoiceStore = store.select(STORE_VAL.product_choice);
    this.postProductsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.postProductChoice = res[0];
      }
    });

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (res.length > 0) {
        this.lifeStylePayloadFromStoreObj = res[0];
      }
    });

    this.dependantDetailsStore = store.select(STORE_VAL.dependant_details);
    this.dependantDetailsStore.subscribe(res => {
      if (res.length > 0) {
        this.dependantDetailsData = res[0];
      }
    });
    store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.isMaturityQuote = val[0].maturityQuote;
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataService();
    this.setBreadcrumb({ url: this.router.url });

    if(this.postProductChoice && this.postProductChoice.selectedProduct && this.postProductChoice.selectedProduct === 'C') {

      if (this.dependantDetailsData) {
        if (this.dependantDetailsData.dependantQuestion === 'Y' || this.lifeStylePayloadFromStoreObj.dependentMedicalConditions.length > 0) {
          const value = { selected: true };
          this.utilService.refreshBreadcrumb(value);
        }
      }

      if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
        this.getTotalMedCount(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
      } else
      if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
        this.getTotalMedCount(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions);
      }
     
      this.toggleBreadcrumbValues();
    }

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.setBreadcrumb(e);
      });

    this.subscription = this.utilService.emitbreadcrumb.subscribe(
      (values) => {
        this.handleBreadcrumbEmitValues(values);
      }
    );
    this.subscription = this.utilService.emitbreadcrumbAfterLogin.subscribe(
      (values) => {
        this.setBreadcrumb(values);
      }
    );    
  }

  private handleBreadcrumbEmitValues(values: Record<string, boolean>): void {
    const rule = UserDataConfig.BreadcrumbToggleRules
      .find(r => values[r.key] === r.expected);

    if (!rule) {
      return;
    }

    this.utilService.toggleBreadcrumb(this.breadcrumbDetails, rule.ids, rule.show);
    this.runExtraAction(rule.extraAction);
  }

  private runExtraAction(action?: string): void {
    switch (action) {
      case 'removeYourLumpSumAllowances':
        this.store.dispatch(new YourLumpSumActions.RemoveYourLumpSumAllowances(0));
        break;
    }
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks test
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setBreadcrumb(val) {
    this.arrBreadcrumb = this.breadcrumbDetails;
    const screenName = this.breadcrumbDetails.find(a => val.url.indexOf(a.path) > -1).screenName || '';
    this.analyticsService.pageTrack({ pageName: screenName });
    if (val === null) {
      this.breadcrumbs = this.arrBreadcrumb.filter((arr, index) => {
        return arr.type === 'intro';
      });
    } else {
      const url = val.url;
      const currentArray = this.arrBreadcrumb.filter((arr, index) => {
        return url.indexOf(arr.path) > -1;
      });
      this.arrBreadcrumb.forEach(element => {
        if ((element.path === MEDICAL_UW_URL.annuitant.medicalConditions && url === MEDICAL_UW_URL.annuitant.AMC ||
          element.path === MEDICAL_UW_URL.annuitant.medicalConditions && url.includes(MEDICAL_UW_URL.annuitant.DMC) ||
          element.path === MEDICAL_UW_URL.annuitant.medicalConditions && url === MEDICAL_UW_URL.annuitant.diabetes) || (
            element.path === MEDICAL_UW_URL.dependant.dependantMedicalConditions && url === MEDICAL_UW_URL.dependant.dependantAMC ||
          element.path === MEDICAL_UW_URL.dependant.dependantMedicalConditions && url.includes(MEDICAL_UW_URL.dependant.dependantDMC) ||
          element.path === MEDICAL_UW_URL.dependant.dependantMedicalConditions && url === MEDICAL_UW_URL.dependant.dependantDiabetes)) {
          element.isActive = true;
        } else if (url.indexOf(element.path) > -1) {
          element.isActive = true;
        } else {
          element.isActive = false;
        }
      });
      if (currentArray.length > 0) {
        this.breadcrumbs = this.arrBreadcrumb.filter((arr, index) => {
          return arr.type === currentArray[0].type;
        });
        if(this.breadcrumbs.find(b => b.screenName === 'OnlineQuote')) {
          this.breadcrumbs.forEach(e => {
            if(e.screenName === 'OnlineQuote') { e.enable = false;}
          });
        }
      }
    }
  }

  toggleBreadcrumbValues(): void {
    if (this.totalMedCount > 0) {
      if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
        this.utilService.refreshBreadcrumb({ hideADL: false });
      } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
        this.utilService.refreshBreadcrumb({ hideDepADL: false });
      }
    } else {
      if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
        this.utilService.refreshBreadcrumb({ hideADL: true });
      } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
        this.utilService.refreshBreadcrumb({ hideDepADL: true });
      }
    }
  }

  getTotalMedCount(medCondList: AnnuitantMedicalConditions[]) {
    this.medCondListFromStore = [];
    medCondList.forEach(element => {
      if ((element.questionSetName === MedicalCondQuestionSet.lifestyle) ||
        element.questionSetName === MedicalCondQuestionSet.adl) {

      }
      else {
        this.medCondListFromStore.push(element);
      }
    });
    if (this.medCondListFromStore.length > 0) {
      this.totalMedCount = this.medCondListFromStore.length;
    }
    else {
      this.totalMedCount = 0;
    }
  }

  /* common method for camel case */
  breadCrumb_toCamelCase(id_value) {
    if (!this.checkIfValueIsEmpty(id_value)) {
      return id_value.toLowerCase()
      // Replaces any - or _ characters with a space
      .replace(/[-_]+/g, ' ')
      // Removes any non alphanumeric characters
      .replace(/[^\w\s]/g, '')
      // Uppercases the first character in each group immediately following a space 
      // (delimited by spaces)
      .replace(/ (.)/g, function ($1) { return $1.toUpperCase(); })
      // Removes spaces
      .replace(/ /g, '');
    }
    return id_value;
  }

    /** Code block for CMS */
  GetCMSDataService() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_Breadcrumbs;
    this.utilService.getCMSData(URL)
      .subscribe(res => {
        this.CMSData = res;
        this.breadcrumbDetails.find(response => response.displayOrder === 3).name = this.CMSData.string_BreadcrumbBeforeYouStart;
        this.breadcrumbDetails.find(response => response.displayOrder === 5).name = this.CMSData.string_BreadcrumbYourPension;
        this.breadcrumbDetails.find(response => response.displayOrder === 6).name = this.CMSData.string_BreadcrumbProductChoice;
        this.breadcrumbDetails.find(response => response.displayOrder === 7).name = this.CMSData.string_BreadcrumbLifestyle;
        this.breadcrumbDetails.find(response => response.displayOrder === 8).name = this.CMSData.string_BreadcrumbMedical;
        this.breadcrumbDetails.find(response => response.displayOrder === 12).name = this.CMSData.string_BreadcrumbADL;
        this.breadcrumbDetails.find(response => response.displayOrder === 13).name = this.CMSData.string_BreadcrumbDoctorsDetails;
        this.breadcrumbDetails.find(response => response.displayOrder === 15).name = this.CMSData.string_BreadcrumbDependantsLifestyle;
        this.breadcrumbDetails.find(response => response.displayOrder === 16).name = this.CMSData.string_BreadcrumbDependantMedical;
        this.breadcrumbDetails.find(response => response.displayOrder === 20).name = this.CMSData.string_BreadcrumbDependantADL;
        this.breadcrumbDetails.find(response => response.displayOrder === 14).name = this.CMSData.string_BreadcrumbDependant;
        this.breadcrumbDetails.find(response => response.displayOrder === 22).name = this.CMSData.string_BreadcrumbOptionsQuote;
        this.breadcrumbDetails.find(response => response.displayOrder === 23).name = this.CMSData.string_BreadcrumbConfirmYourDetails;
        this.breadcrumbDetails.find(response => response.displayOrder === 28).name = this.CMSData.string_BreadcrumbBeforeYouApply;
        this.breadcrumbDetails.find(response => response.displayOrder === 29).name = this.CMSData.string_BreadcrumbApplyPersonalDetails;
        this.breadcrumbDetails.find(response => response.displayOrder === 30).name = this.CMSData.string_BreadcrumbApplyHealthRecords;
        this.breadcrumbDetails.find(response => response.displayOrder === 31).name = this.CMSData.string_BreadcrumbApplyDependantPersonalDetails;
        this.breadcrumbDetails.find(response => response.displayOrder === 32).name = this.CMSData.string_BreadcrumbApplyDependantsHealthRecords;
        this.breadcrumbDetails.find(response => response.displayOrder === 33).name = this.isMaturityQuote ? 'Your maturity value' : this.CMSData.string_BreadcrumbPensionSavings;
        this.breadcrumbDetails.find(response => response.displayOrder === 34).name = 'Lump sum allowances';
        this.breadcrumbDetails.find(response => response.displayOrder === 35).name = this.CMSData.string_BreadcrumbBeneficiary;
        this.breadcrumbDetails.find(response => response.displayOrder === 36).name = this.CMSData.string_BreadcrumbPaymentDetails;
        this.breadcrumbDetails.find(response => response.displayOrder === 37).name = this.CMSData.string_BreadcrumbSign;
      });
  }
/** End of code block for CMS */

getBreadcrumbStatus(val) {
  if (val) {
    return 'active';
  } else {
    return 'inActive';
  }
}
checkIfValueIsEmpty(val) {
  if (val === undefined || val === null || val === '') {
    return true;
  }
  return false;
}
}
